import { Variants } from 'framer-motion'

export const zoomDefaultSize1280And1366 = 4
export const zoomDefault = 5
export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const introLeftVariants: Variants = {
  hide: {
    opacity: 0,
    x: -160,
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 2,
    },
  },
}

export const introRightVariants: Variants = {
  hide: {
    opacity: 0,
    x: 160,
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 2,
    },
  },
}

export const introBottomVariants: Variants = {
  hide: {
    opacity: 0,
    y: 160,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 2,
    },
  },
}

export const introOpacityVariants: Variants = {
  hide: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: {
      delay: 1,
      duration: 2,
    },
  },
}
